<template>
  <v-container fluid>
    <v-card class="elevation-2 py-0 px-2 mt-0 rounded-lg">
      <v-row class="px-4 pt-3">

        <v-col cols="3">
        <RangeFilter
          :end="dateEnd"
          :start="dateStart"
          @getDates="getDates"
          :excludePeriod="excludePeriodReport"
          :defaultPeriod="defaultPeriodReport"
          :setDates="true"
          :disabled="loaded"
          ref="ReportRangePicker"
        />
      </v-col>


        <v-col cols="12" md="5" class="pb-0">
          <v-text-field
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            outlined
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="8" md="2" class="pb-0 pl-0 pl-md-0 pl-3">
          <v-select v-model="searchMatch" :items="['contains','equals']" outlined dense label="Search Match"></v-select>
        </v-col>
        <v-btn
          color="#3F51B5"
          class="mt-3 mr-3"
          dark
          depressed
          height='40'
          max-width='40'
          min-width='40'
          @click="loadData"
        >
          <v-icon>
            mdi-magnify
          </v-icon>
        </v-btn>
        <v-btn
          color="#3F51B5"
          class="mt-3"
          dark
          depressed
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>       
      </v-row>
      <v-row class="px-4 pb-3">
        <v-col cols="12" sm="6" lg="4" class="pb-0">
          <v-autocomplete
            v-model="selectedCampaign"
            :items="campaigns"
            item-text="name"
            item-value="id"
            label="Campaigns"
            outlined
            dense
            clearable
            class="text-body-2 text-capitalize ma-0 pr-0 pb-0"
            hide-details
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" lg="2" xl="1" class="pb-0">
            <v-menu
                v-model="menuBulkEdit"
                :close-on-content-click="false"
                bottom
                offset-y
                :nudge-top="40"
                :max-width="350"
                v-if="managementRight"
                persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :disabled="selected.length == 0"
                    color="indigo white--text"
                    class="pa-5 text-body-2 text-capitalize elevation-2"
                    @click="cleanSelectedAction"
                >
                  Edit
                  <v-icon class="ml-1">
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-dialog v-model="dialogConfirmBulkAction" persistent max-width="500px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Confirmation</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        Are you sure you want to {{ selectedActionConfirmText }} {{ selected.length }} selected
                        keywords?
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="cancelAction()"
                    >
                      No
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="applyAction()"
                    >
                      Yes
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-card>
                <v-list>
                  <v-list-item-group color="primary" v-model="selectedInxAction">
                    <v-list-item
                      v-for="(action, i) in bulkActions"
                      :key="i"
                      :disabled="action.disabled"
                      @click="selectAction(i)"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-icon v-text="action.icon" :color="action.color"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-action v-text="action.text" class="ml-0 text-capitalize">
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
        <v-col cols="12" sm="4" lg="2" class="pb-0">
          <v-switch
            v-model="hideZeroOrders"
          >
            <template v-slot:label>
              <div class="ml-1">Hide Zero Total Orders</div>
            </template>
          </v-switch>
        </v-col>
        <v-col cols="12" sm="4" lg="2" class="pb-0">
          <v-switch
            v-model="hideStoppedItems"
          >
            <template v-slot:label>
              <div class="ml-1">Hide Stopped Status</div>
            </template>
          </v-switch>
        </v-col>
        <v-col cols="12" sm="4" lg="2" class="pb-0">
          <v-switch
            v-model="hideRemovedItems"
          >
            <template v-slot:label>
              <div class="ml-1">Hide Removed Status</div>
            </template>
          </v-switch>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialogHistory" max-width="600px">
      <v-card>
        <v-card-title>
          <span>Rank History</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text v-if="loadedHistory">
          <p class="mt-4 text-center">Loading... Please wait</p>
          <v-progress-linear
            color="indigo"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text v-else>
          <RangeFilter
            class="mb-7 mt-1"
            :end="dateEndHistory"
            :start="dateStartHistory"
            @getDates="getDatesHistory"
            :excludePeriod="excludePeriod"
            :defaultPeriod="defaultPeriod"
            :disabled="loadedHistory"
          />
          <LineChart :chart-data="rankHistory"/>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="indigo white--text"
            text
            @click="closeHistory"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-row class="px-2 mt-5">
        <v-spacer></v-spacer>
        <v-col cols="7" md="6" sm="9" class="d-flex justify-end pb-0 pt-0 mt-0">
          <v-spacer></v-spacer>
          <vue-excel-xlsx
            :data="dataFilteredForExcel"
            :columns="columnsData"
            :filename="`Keywords Report`"
            :sheetname="`${createSheetName}`"
          >
            <v-btn
              height="39"
              min-width="39px"
              class="ml-auto mr-5 rounded-lg pa-0 ma-0"
              color="white"
            >
              <ExportExcel/>
            </v-btn>
          </vue-excel-xlsx>
          <CustomColumns
            :currentValue="value"
            :currentCustomHeader="customHeader"
            :currentHeaders="headers"
            :settingsName="settingsName"
            @getCustomData="getCustomData"
          />
        </v-col>
      </v-row>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn
              class="mx-2 scroll-btn btn-left"
              fab
              small
              @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right"
              fab
              small
              @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
            :headers="selectedHeaders"
            :items="filteredKeywords"
            v-model="selected"
            dense
            item-key="id"
            class="elevation-0 mt-2 table-main-container"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :show-select="managementRight"
            :options.sync="options"
            :server-items-length="totalKeywords"
            :loading="loaded"
            fixed-header
            loading-text="Loading... Please wait"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"
            @click:row="rowClick"
            :search="search"
          >
            <template v-slot:item.keyword="{ item }">
              <div class="d-flex text-truncate align-center">
                <v-dialog v-if="item.search_term_keyword.length > 0" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" bottom class="">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <template v-slot:default="dialog">
                    <v-card>
                      <v-card-title>{{item.keyword}}</v-card-title>
                      <v-divider></v-divider>
                      <v-data-table
                        :headers="[
                                    {text: 'Search Term', value: 'query'},
                                    {text: 'Ad Group', value: 'ad_group'},
                                    {text: 'Day', value: 'day'}
                                  ]"
                        :items="item.search_term_keyword"
                      >
                        <template v-slot:item.day="{ item }">
                          <span>{{ item.day | formatDate }}</span>
                        </template>
                      </v-data-table>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="green darken-1"
                          text
                          @click="dialog.value = false"
                        >
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
                <span :class="[item.search_term_keyword.length > 0 ? 'ml-2' : 'ml-8', 'text-left']">{{ item.keyword }}</span>
              </div>
            </template>
            <template v-slot:item.campaign="{ item }">
              <div class="d-flex text-truncate align-center">
                <v-dialog v-if="item.search_term_campaign.length > 0" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" bottom class="flex-grow-0 flex-shrink-0">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <template v-slot:default="dialog">
                    <v-card>
                      <v-card-title>{{item.campaign}}</v-card-title>
                      <v-divider></v-divider>
                      <v-data-table
                        :headers="[
                                    {text: 'Search Term', value: 'query'},
                                    {text: 'Ad Group', value: 'ad_group'},
                                    {text: 'Day', value: 'day'}
                                  ]"
                        :items="item.search_term_campaign"
                      >
                        <template v-slot:item.day="{ item }">
                          <span>{{ item.day | formatDate }}</span>
                        </template>
                      </v-data-table>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="green darken-1"
                          text
                          @click="dialog.value = false"
                        >
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
                <span :class="[item.search_term_campaign.length > 0 ? 'ml-2' : 'ml-8', 'text-left']">{{ item.campaign }}</span>
              </div>
            </template>
            <template v-slot:item.total_gallon_goal="{ item }">
              <span v-if="item.total_gallon_goal > 0 ">{{
                  item.total_gallon_goal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}</span>
              <span v-if="item.total_gallon_goal == 0">0</span>
            </template>
            <template v-slot:item.ads_type="{ item }">
              <span v-if="item.ads_type == 1">Google Ads</span>
              <span v-if="item.ads_type == 2">Bing Ads</span>
            </template>
            <template v-slot:item.total_gallons="{ item }">
              <span v-if="item.total_gallons>0">{{
                  item.total_gallons.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}</span>
              <span v-if="item.total_gallons==0">0</span>
            </template>
            <template v-slot:item.total_spent="{ item }">
              <span v-if="item.total_spent>0">$ {{ item.total_spent | formatPrice }}</span>
              <span v-if="item.total_spent==0">0</span>
            </template>
            <template v-slot:item.total_calls="{ item }">
              <span v-if="item.total_calls>0">{{
                  item.total_calls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}</span>
              <span v-if="item.total_calls==0">0</span>
            </template>
            <template v-slot:item.total_conversations="{ item }">
              <span v-if="item.total_conversations>0">{{
                  item.total_conversations.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}</span>
              <span v-if="item.total_conversations==0">0</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import LineChart from '@/utils/charts/LineChart'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'
import {ParseDateRange}  from "@/utils/EDateRangeParse"

export default {
  components: {
    RangeFilter,
    LineChart,
    CustomColumns,
    ExportExcel
  },
  data() {
    return {
      totalKeywords: 0,
      hideAnything: false,
      selected: [],
      selectedCampaign: null,
      allCampaigns: [],
      campaigns: [],
      hideZeroOrders: false,
      hideStoppedItems: false,
      hideRemovedItems: true,
      role: null,
      rights: [],
      dialogConfirmBulkAction: false,
      menuBulkEdit: false,
      searchMatch: 'contains',
      selectedInxAction: null,
      bulkActions: [
        {text: 'Enable Keyword', value: 'resume', icon: 'mdi-play-circle', color: 'green', confirmation: 'enable'},
        {text: 'Pause Keyword', value: 'pause', icon: 'mdi-pause-circle', color: 'grey', confirmation: 'pause'}
      ],
      selectedActionConfirmText: "",
      search: '',
      sortBy: 'total_gallons',
      sortDesc: true,
      options: {},
      headers: [
        {text: 'Google Ads/Bing Ads', value: 'ads_type', class: 'black--text'},
        {text: 'Keyword', value: 'keyword', class: 'black--text'},
        {text: 'Campaign', value: 'campaign', class: 'black--text'},
        {text: 'Ad Group Name', value: 'ad_name', class: 'black--text'},
        {text: 'Match Type', value: 'match_type', class: 'black--text'},
        {text: 'Status', value: 'status', class: 'black--text'},
        {text: 'Total Orders', value: 'total_orders', class: 'black--text'},
        {text: 'Total Gallons K/C', value: 'total_gallons', class: 'black--text'},
          {text: 'Potentials Gallons K/C', value: 'p_gallons', class: 'black--text'},
        {text: 'Total in Direct sales', value: 'total_gallon_goal', class: 'black--text'},
        {text: 'Total in Calls', value: 'total_gallon_call', class: 'black--text'},
        {text: 'Total In Web Inquires', value: 'total_gallon_inquires', class: 'black--text'},
        {text: 'Rank K/C', value: 'rank_keyword_campaign', class: 'black--text'},
        {text: 'Total Conversions', value: 'total_conversations', class: 'black--text'},
        {text: 'Total Calls', value: 'total_calls', class: 'black--text'},
        {text: 'Total Spent', value: 'total_spent', class: 'black--text'},
      ],
      customHeader: ['ads_type', 'keyword', 'campaign', 'ad_name', 'match_type', 'status', 'total_orders',
        'total_gallons', 'total_gallon_goal', 'total_gallon_call', 'total_gallon_inquires',
        'rank_keyword_campaign', 'total_conversations', 'total_calls', 'total_spent'],
      selectedHeaders: [],
      value: [
        {text: 'Google Ads/Bing Ads', value: 'ads_type', class: 'black--text'},
        {text: 'Keyword', value: 'keyword', class: 'black--text'},
        {text: 'Campaign', value: 'campaign', class: 'black--text'},
        {text: 'Ad Group Name', value: 'ad_name', class: 'black--text'},
        {text: 'Match Type', value: 'match_type', class: 'black--text'},
        {text: 'Status', value: 'status', class: 'black--text'},
        {text: 'Total Orders', value: 'total_orders', class: 'black--text'},
        {text: 'Total Gallons K/C', value: 'total_gallons', class: 'black--text'},
          {text: 'Potentials Gallons K/C', value: 'p_gallons', class: 'black--text'},
        {text: 'Total in Direct sales', value: 'total_gallon_goal', class: 'black--text'},
        {text: 'Total in Calls', value: 'total_gallon_call', class: 'black--text'},
        {text: 'Total In Web Inquires', value: 'total_gallon_inquires', class: 'black--text'},
        {text: 'Rank K/C', value: 'rank_keyword_campaign', class: 'black--text'},
        {text: 'Total Conversions', value: 'total_conversations', class: 'black--text'},
        {text: 'Total Calls', value: 'total_calls', class: 'black--text'},
        {text: 'Total Spent', value: 'total_spent', class: 'black--text'}
      ],
      settingsName: 'keywordsReport',
      data: [],
        excludePeriodReport:[],
        defaultPeriodReport:4,
        dateStartReport:new Date(
            Date.UTC(
                new Date().getFullYear(),
                new Date().getMonth(),
                1)).toISOString().substr(0, 10),

        dateEndReport: new Date().toISOString().substr(0, 10),
        isDateReposrtSelect:false,
        dateRangeSelectItem:0,

        filteredKeywords: [],
      historyChanged: [],
      userName: null,
      loaded: false,
      campaignSelectedId: 0,
      dialogHistory: false,
      loadedHistory: false,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
                  Date.UTC(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1)).toISOString().substr(0, 10),
      excludePeriod: [],

      dateEndHistory: new Date().toISOString().substr(0, 10),
      dateStartHistory: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),

      defaultPeriod: 3,
      rankHistory: null,
      selectedKeyword: null,
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
    }
  },
  watch: {
    options: {
      handler () {
        this.loadData()
      },
      deep: true,
    },
    selectedCampaign: function (val) {
      this.campaignSelectedId = val
      this.loadData()
    },
    hideZeroOrders: function () {
      this.loadData()
    },
    hideStoppedItems: function () {
      this.loadData()
    },
    searchMatch: function () {
      this.loadData()
    },
    hideRemovedItems: function () {
      this.loadData()
    },
    hoverOnTable() {
      this.showScrollingArrows()
    },
    value(val) {
      this.selectedHeaders = val
      this.getHeaderForExcel()
    }
  },
  created() {
    this.selectedHeaders = this.value
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrows)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    this.loaded = true
    axios
        .get('/username')
        .then(response => (this.userName = response.data))

    axios
        .get('/users/me')
        .then(response => {
          this.role = response.data.data.role
          this.rights = response.data.data.rights
        })

    let userName = localStorage.getItem('username')
    let settings = this.settingsName
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
    if (localStorage.getItem(`${userName}.${clientId}.${settings}`)) {

      try {

        let valueCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}`))
        this.value = valueCash.filter(e => this.headers.find(item => item.value === e.value))

        const parsed = JSON.stringify(this.value)
        localStorage.setItem(`${userName}.${clientId}.${settings}`, parsed)

        this.customHeader = this.value.map(e => e.value)

        this.getHeaderForExcel()
      } catch (e) {
        console.log("")
      }
    }

    axios
        .get('/campaigns')
        .then(response => {
          this.allCampaigns = response.data
          this.campaigns = this._.chain(this.allCampaigns)
              .groupBy("campaignId")
              .map((value, key) => ({id: key, name: value[0].campaignName}))
              .value();
        })

    this.loadData()
    this.showScrollingArrows()
  },
  computed: {
    managementRight() {
        if(!this.rights) return false;
      return (this.role === "Admin")
          ? true
          : this.rights.includes('cruiseCampaignManagement')
    },
    dataFilteredForExcel() {
      let data = JSON.parse(JSON.stringify(this.filteredKeywords))
      data.map(e => {
        e.ads_type = (e.ads_type == 1) ? 'Google Ads' : 'Bing Ads'
        e.total_spent = parseFloat(e.total_spent.toFixed(2))
      })

      return data
    },
    createSheetName() {
      let name = 'Keywords Report'
      if (name.length > 30) name = name.substr(0, 30)
      name = name.replace(/(\\|\/)/g, '-')
      return name
    }
  },
  methods: {
    applyAction() {
      switch (this.selectedAction) {
        case 'pause':
          this.changeStatus("PAUSED")
          break;
        case 'resume':
          this.changeStatus("ENABLED")
          break;
      }

      this.selectedAction = ''
      this.dialogConfirmBulkAction = false
      this.menuBulkEdit = false
    },
    selectAction(i) {
      this.selectedAction = this.bulkActions[i].value
      this.selectedActionConfirmText = this.bulkActions[i].confirmation
      this.dialogConfirmBulkAction = true
    },
    changeStatus(status) {
      let payload = []
      let clonedSelected = JSON.parse(JSON.stringify(this.selected))
      for (let c of clonedSelected) {
        for (let dat of this.filteredKeywords) {
          if (c.keyword_id == dat.keyword_id && c.ad_group_id == dat.ad_group_id) {
            payload.push({
              "ad_group_id": dat.ad_group_id,
              "keyword_id": dat.keyword_id,
              "mode": status,
              "ads_type": c.ads_type
            })

            if (status === "ENABLED") {
              dat.status = 'Active'
            } else {
              dat.status = 'Stopped'
            }
          }
        }
      }

      axios({
        url: '/status-by-ads-type',
        method: 'put',
        data: payload
      })
    },
    cancelAction() {
      this.selectedAction = ''
      this.selectedActionConfirmText = ''
      this.dialogConfirmBulkAction = false
      this.menuBulkEdit = false
    },
    cleanSelectedAction() {
      this.selectedInxAction = null
    },
    scrollingRight() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right')
      const btnLeft = document.querySelector('.btn-left')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left')
      const btnRight = document.querySelector('.btn-right')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows() {
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right')
      const btnLeft = document.querySelector('.btn-left')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    getDatesHistory(dates) {
      this.dateStartHistory = dates.dateStart
      this.dateEndHistory = dates.dateEnd
      this.getRankHistory(this.selectedKeyword)
    },
    closeHistory() {
      this.dialogHistory = false
      this.loadedHistory = false
    },
    getRankHistory(item) {
      this.selectedKeyword = item
      this.dialogHistory = true
      this.loadedHistory = true

      axios
          .get('/rank-history/' + this.selectedKeyword.keyword_id + '/' + this.selectedKeyword.campaign_id + '/' + this.dateStartHistory + '/' + this.dateEndHistory)
          .then(response => {

            this.rankHistory = {
              'labels': response.data.data.map(el => el.createdDate.split(' ')[0]),
              'datasets': [
                {
                  label: 'Rank',
                  borderColor: 'rgba(99, 114, 195, 1)',
                  backgroundColor: 'rgba(242, 243, 252, 0.4)',
                  borderWidth: 1,
                  data: response.data.data.map(el => el.rank.toFixed(2))
                }
              ]
            }
            this.loadedHistory = false
          });

    },
    loadData() {
      this.loaded = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      this.selected = [];
        let typeRange = this.dateRangeSelectItem;

      axios
          .get(`/dashboard/rank?hideZeroOrder=${this.hideZeroOrders}&sortBy=${sortBy}`+
          `&sortDesc=${sortDesc}&page=${page}&itemsPerPage=${itemsPerPage}&campaign=${this.selectedCampaign}`
          +`&hideStopStatus=${this.hideStoppedItems}&hideRemovedStatus=${this.hideRemovedItems}&search=${this.search}&searchMatch=${this.searchMatch}`
              +`&searchStartDate=${this.dateStartReport}` +`&searchEndDate=${this.dateEndReport}` + `&typeRange=${typeRange}`
          )
          .then(response => {
            this.data = response.data
            this.totalKeywords = this.data.total
            let data = this._.compact(this.data.keyword_campaign)

            let counter = 0
            this.filteredKeywords = data.map(e => {
              e.id = counter++
              return e
            })

            this.loaded = false
          })
    },
    cleanFilters() {
      this.search = ''
      this.loadData()
    },
    rowClick: function (item, row) {
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getCustomData({customHeader, value, selectedHeaders}) {
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders

      this.getHeaderForExcel()
    },
    getHeaderForExcel() {
        if(!this.selectedHeaders) return;
      this.columnsData = this.selectedHeaders.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        if (e.value === "total_spent") {
          obj.label = `${e.text},$`
          obj.field = e.value
        }
        return obj
      }).filter(value => Object.keys(value).length !== 0)
    },
      getDates(dates) {
          this.dateStartReport = dates.dateStart
          this.dateEndReport = dates.dateEnd
          //this.pagination.page = 1
          let index_select_item = this.$refs.ReportRangePicker.$data.model;
          if(!index_select_item) return;
          let dstart = this.$refs.ReportRangePicker.$data.dateStart
          let dend = this.$refs.ReportRangePicker.$data.dateEnd
          let ranges = this.$refs.ReportRangePicker.$data.ranges
          this.dateRangeSelectItem = ParseDateRange(dstart, dend,ranges);

          this.loadData();
      },

    }
}
</script>

<style scoped>
  .v-input--selection-controls {
    margin-top: 8px !important;
  }

  div.v-input__slot > label {
    left: 10px !important;
  }

  .btn-right {
    right: 0px;
    top: 70px;
  }

  .btn-left {
    left: 0px;
    top: 70px;
  }
</style>